export const TRANSFER_SLIP_PRINT_ROOT = 'xsib-transfer-slip-print'

export const SLIP_WIDTH_MM = 210
export const SLIP_HEIGHT_MM = 148

export const TRANSFER_SLIP_PRINT_CSS = `
  .${TRANSFER_SLIP_PRINT_ROOT} { display: none; }
  @media print {
    @page { size: A5 landscape; margin: 0; }
    html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    body > *:not(.${TRANSFER_SLIP_PRINT_ROOT}) { display: none !important; }
    .${TRANSFER_SLIP_PRINT_ROOT} { display: block; width: ${SLIP_WIDTH_MM}mm; }
  }
`

const LOGO_WAIT_MS = 3000

export async function transferSlipImagesSettled(): Promise<void> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(`.${TRANSFER_SLIP_PRINT_ROOT} img`))
  const decodes = images.map((image) => image.decode().catch(() => undefined))
  const timeout = new Promise<void>((resolve) => setTimeout(resolve, LOGO_WAIT_MS))
  await Promise.race([Promise.all(decodes).then(() => undefined), timeout])
}
